import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ROUTES } from 'utils/constants';
import { useEvieAppContext } from '../EvieAppProvider';

import EvieGreeting from '../EvieGreeting';
import DailyTasksCard from '../DailyTasksCard';
import ProgramInfoCard from '../ProgramInfoCard';
import SeeMoreButton from '../SeeMoreButton';
import GoPlusCard from '../GoPlusCard';
import AdditionalContent from '../AdditionalContent';
import ScheduleCallCard from '../ScheduleCallCard';

const HomeContent = () => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const { isAppointmentActive } = useEvieAppContext();

  return (
    <section className="evie-home">
      <EvieGreeting />
      <DailyTasksCard />
      {isAppointmentActive ? <ScheduleCallCard /> : null}
      <GoPlusCard />
      <ProgramInfoCard />
      <h2 className="evie-home__programtitle">{t('evieApp.programTitle')}</h2>
      <SeeMoreButton content={t('evieApp.seeMore.weekLabel')} action={() => push(ROUTES.EVIE_MY_PROGRAM)} />
      <AdditionalContent />
    </section>
  );
};

export default HomeContent;
